import React,{useContext, useEffect,useState} from 'react';
import MainMenu from './../../../components/mainMenu/MainMenu';
import LeftSitebarMenu from './../../../components/leftSitebarMenu/LeftSitebarMenu';
import RightSitebarMenu from './../../../components/rightSitebarMenu/RightSitebarMenu';
import closerIcon from '../../../assets/img/feed-imgs/navbar/closeicon.svg';
import { ShowHideSitebar } from './../../../App';
import { useParams } from 'react-router-dom';
import { singleEventPostDetails as singleEventPostDetailsApi} from '../../../api';
import '../ShowAllEvents/ShowAllEvents.css';
import EventTopBanner from './../componets/EventTopBanner';
import EventsFilterSection from './../componets/EventsFilterSection';
import EventDetailsPost from '../componets/EventDetailsPost';
import EventShortCart from '../componets/EventShortCart';
import EventDetailsDescription from '../componets/EventDetailsDescription';


const EventsDetails = () => {
    const params = useParams()
    const [showHideSidebar, setShowHideSidebar] = useContext(ShowHideSitebar)
    useEffect(()=>{ /** setting the page name for the sidebars of this page to work */
        const setPageName = {...showHideSidebar}
        setPageName.pageName = 'blogs';
        setPageName.blogs.left = false;
        setPageName.blogs.right = false;
        setShowHideSidebar(setPageName)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    const closeSidebar =(whichSidebar, status)=>{
        const newStatus = {...showHideSidebar}
        if(whichSidebar === 'left'){
            newStatus.blogs.left = status /** changing the page name for left sidebar to toggle */
            setShowHideSidebar(newStatus) /** changing the page name for right sidebar to toggle */
        }
        if(whichSidebar === 'right'){
            newStatus.blogs.right = status
            setShowHideSidebar(newStatus)
        }
    }
    // Fetch data in single Event Details Parpuss 

    const [postFetchDatas, setPostFetchDatas] = useState([])

    useEffect( ()=>{
        singleEventPostDetailsApi().then( data =>setPostFetchDatas(data[Number(params?.id)]))
    },[])
    console.log("Post Fetch Datas",postFetchDatas)
    return (
        <div>
            <MainMenu></MainMenu>
            {/* Menu bar start here */}
            <div className="container-fluid container-xxl">
                <div className="row gap-5 gap-lg-0">
                    {/* Left Site Bar Start here */}
                    <div className={`col-12 col-lg-2  d-lg-block ${showHideSidebar?.blogs?.left ? 'd-block right-sitebarmenu' : 'd-none'}`}>
                        <div className="d-flex d-lg-none justify-content-end mb-3">
                            <div onClick={()=>closeSidebar("left", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <LeftSitebarMenu></LeftSitebarMenu>
                    </div>    
                    {/* left Site Bar End Hre */}

                    {/* Center Align Items Code start Here*/}

                    <div className="col-12 col-lg-10">
                        {/* Top Banner Section */}
                        <div className="row mb-3">
                           <EventTopBanner />
                        </div>
                        <EventsFilterSection />
                        <div className="row">
                            {/* Event Details page Post Are here */}
                            <EventDetailsPost />
                            <div className="col-12 col-lg-5">
                                {/* Short Card in Right site Event Details Page */}
                                <EventShortCart />
                                {/* Descritption Part in Event Details Page */}
                                <EventDetailsDescription />
                            </div>
                        </div>
                    </div>
                    <div className={`col-12 col-lg-4  d-none-lg ${showHideSidebar?.blogs?.right ? 'd-blog right-sitebarmenu' : 'd-none'}`}>
                    <div className="d-flex d-lg-none justify-content-end my-2">
                        <div onClick={()=>closeSidebar("right", false)} className="d-flex justify-content-center align-items-center action-button rounded-circle shadow-sm p-2 m-3" style={{ height: "32px", width: "32px"}}>
                                <img src={closerIcon} alt="" className='close-menu-button' />
                            </div>
                        </div>
                        <RightSitebarMenu />
                    </div>          
                </div>
            </div>
        </div>
    );
};

export default EventsDetails;